import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ShareModal = styled.div`
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  max-height: calc(-50px + 100vh);
  height: 100%;
  border-radius: 20px 20px 0 0;
  overflow: hidden;

  .content {
    .cont-text {
      ${mixin.flex({})};
      padding: 0 36px;

      .fixed-text,
      .ellipsis-text {
        font-size: 14px;
        line-height: 150%;
        color: #555;
      }

      .ellipsis-text {
        ${mixin.ellipsis(1)};
      }

      .fixed-text {
        flex-shrink: 0;
      }

      &:has(.fixed-text) {
        padding: 0 65px;
      }
    }

    .sns-list {
      padding: 32px 0;
      ${mixin.flex({})};
      column-gap: 24px;
    }
  }

  .btn-close {
    width: 100%;
    height: 50px;
    border-top: 1px solid #eee;

    span {
      font-size: 16px;
      font-weight: 500;
      color: #000;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20 20 0 0')};

    .content {
      .cont-text {
        padding: ${mixin.pxToVw('0 36')};

        .fixed-text,
        .ellipsis-text {
          font-size: ${mixin.pxToVw('14')};
        }

        &:has(.fixed-text) {
          padding: ${mixin.pxToVw('0 65')};
        }
      }

      .sns-list {
        padding: ${mixin.pxToVw('32 0')};
        column-gap: ${mixin.pxToVw('24')};
      }
    }

    .btn-close {
      height: ${mixin.pxToVw('50')};

      span {
        font-size: ${mixin.pxToVw('16')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    max-height: none;
    height: auto;
    border-radius: 0;

    .modal-title {
      padding: 30px 12px 24px 32px;
      margin-bottom: 0;

      .title {
        text-align: left;
        font-size: 24px;
      }
    }

    .modal-close-btn {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;
    }

    .content {
      padding: 0 32px 28px 32px;

      .cont-text {
        width: 386px;
        padding: 0 8px;

        .fixed-text,
        .ellipsis-text {
          font-size: 18px;
          line-height: 135%;
        }

        &:has(.fixed-text) {
          padding: 0 35px;
        }
      }

      .sns-list {
        width: 386px;
      }
    }
  }
`;
